/* eslint-disable import/prefer-default-export */

export enum Locale {
  En = 'en',
  Fr = 'fr'
}
